<body>
  <section class="background">
    <canvas id="canvas" class="w-100 h-100"></canvas>
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-4">
          <div class="logo text-center">
            <img src="{{ onPassiveBaseUrl }}onpassive(dec-17)/image/logo.png" alt="logo"/>
          </div>
        </div>
        <div class="col-lg-4"></div>
        <div class="col-lg-4 mt-2">
          <div class="social-image text-right">
            <a
              href="http://onpassive.com/blog"
              target="_blank"
              rel="noopener"
              class="icon1"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(dec-17)/image/icon/blog1.png"
                title="ONPASSIVE Blog" alt="blog1"
              />
            </a>
            <a
              href="https://www.facebook.com/ONPASSIVE/ONPASSIVE"
              target="_blank"
              rel="noopener"
              class="icon1"
            >
              <img
                src="{{ onPassiveBaseUrl }}onpassive(dec-17)/image/icon/fb.png"
                title="Facebook" alt="facebook"
              />
            </a>
            <a
              href="https://twitter.com/ONPASSIVE"
              target="_blank"
              rel="noopener"
              class="icon1"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(dec-17)/image/icon/twitter.png"
                title="Twitter" alt="twitter"
              />
            </a>
            <a
              href="https://www.instagram.com/ONPASSIVE/"
              target="_blank"
              rel="noopener"
              class="icon1"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(dec-17)/image/icon/insta.png"
                title="Instagram" alt="Instagram"
              />
            </a>
            <a
              href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
              target="_blank"
              rel="noopener"
              class="icon1"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(dec-17)/image/icon/youtube.png"
                title="Youtube" alt="YouTube"
              />
            </a>
            <a
              href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
              target="_blank"
              rel="noopener"
              class="icon1"
            >
              <img
                src="{{ onPassiveBaseUrl }}onpassive(dec-17)/image/icon/in.png"
                title="LinkedIn" alt="LinkedIn"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-2"></div>
        <div class="col-lg-8">
          <div class="row">
            <div class="col-lg-12 text-center">
              <div class="content">
                <h3
                  class="content2"
                  data-aos="flip-left"
                  data-aos-easing="ease-out-cubic"
                  data-aos-duration="2000"
                >
                  Outstanding Internet
                  <span class="revolutionized">Marketing</span><br />
                  Solutions that Drives Results
                </h3>
                <h3 data-aos-easing="linear">
                  <!--   <h1 class="content3">LAUNCHING SOON!</h1> -->
                  <p class="content4">
                    It is that time of the year again, moments that bring out
                    the best in you. Make sure you focus those positive vibes to
                    something useful. ONPASSIVE, a one time opportunity for you
                    to witness the future. With full-fledged AI-driven marketing
                    solutions, we are on a mission to mould the world of
                    marketing.
                  </p>
                </h3>
              </div>
              <div class="video-box">
                <video
                  id="my-video"
                  class="
                    video-js video-size
                    w-100
                    h-auto
                    my-video-dimensions
                    shadow
                  "
                  controls
                  preload="auto"
                  poster="{{ myLinksS3URL }}images/Image0231.png"
                  data-setup="{}"
                  autoplay="true"
                  muted
                >
                  <source
                    src="{{
                      myLinksS3URL
                    }}videos/Onpassive_launching_page_video2.mp4"
                    type="video/mp4"
                  />
                </video>
              </div>
              
            </div>
          </div>
        </div>
        <div class="col-lg-2 mt-5">
          <div class="gift mt-5">
            <img src="{{ onPassiveBaseUrl }}onpassive(dec-17)/image/gift.png" alt="gift"/>
          </div>
        </div>
        <div class="col-lg-4"></div>
        <div class="col-lg-4 button-top">
          <a
            href="/registration/user?reg={{ userId }}"
            name="regform"
            target="_blank"
            rel="noopener"
            class="chirtmas"
            >BECOME A FOUNDER NOW</a
          >
        </div>
        <div class="col-lg-4 mt-3 margin3">
          <h2 class="ml7">
            <span class="letters">Launching Soon!</span>
          </h2>
         
        </div>
      </div>
    </div>
  </section>
</body>
